import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';

import {
  CHANNEL_TYPES,
  ADINSIGHT_LOG_ACTION_TYPE,
  DOWNLOAD_SCOPE,
  NOT_SUPPORT_DOWNLOAD_TYPES,
} from '@bingads-webui-campaign/recommendation-core';
import { ToolbarButton } from './toolbar-button';

export class DownloadToolbarButton extends React.PureComponent {
  static propTypes = {
    channel: PropTypes.string,
    campaignType: PropTypes.number,
    className: PropTypes.string,
    downloadService: PropTypes.objectOf(PropTypes.any),
    filterService: PropTypes.objectOf(PropTypes.any),
    i18n: PropTypes.PropTypes.shape({
      getString: PropTypes.func.isRequired,
    }).isRequired,
    type: PropTypes.string,
    data: PropTypes.objectOf(PropTypes.any),
    logOpportunityEvent: PropTypes.func,
    context: PropTypes.shape({
      Level: PropTypes.string.isRequired,
    }).isRequired,
    title: PropTypes.string,
    isOptimizationScoreOn: PropTypes.bool,
  };

  static defaultProps = {
    channel: null,
    campaignType: null,
    className: 'btn btn-secondary',
    downloadService: null,
    filterService: null,
    type: null,
    data: null,
    logOpportunityEvent: null,
    title: undefined,
    isOptimizationScoreOn: false,
  };

  handleDownloadAll = () => {
    const self = this;
    self.props.downloadService.download({
      channel: self.props.channel,
      campaignType: self.props.campaignType,
      filterService: self.props.filterService,
      recommendationType: self.props.type,
    }).then(() => {
      _.each(_.omit(self.props.data, NOT_SUPPORT_DOWNLOAD_TYPES), (data) => {
        self.props.logOpportunityEvent({
          type: data.type,
          action: ADINSIGHT_LOG_ACTION_TYPE.DOWNLOAD,
          context: _.extend({
            Version: data.version,
            DownloadScope: DOWNLOAD_SCOPE.ALL,
          }, self.props.context),
        });
      });
    });
  };

  render() {
    const {
      i18n, downloadService, channel, isOptimizationScoreOn,
    } = this.props;

    if (downloadService == null) {
      return null;
    }

    let text;
    if (channel === CHANNEL_TYPES.COMPETITION) {
      text = i18n.getString('Details_View_Download_All');
    } else {
      text = i18n.getString('Details_View_Download_All_Rec');
    }

    const buttonProps = _.pick(this.props, 'className', 'disabled', 'title');
    const buttonIconClassName = 'iconba iconba-Download';
    return (
      <ToolbarButton
        id="button-download"
        onClick={this.handleDownloadAll}
        {...buttonProps}
      >
        <span className={buttonIconClassName} />
        {!isOptimizationScoreOn && text}
      </ToolbarButton>
    );
  }
}
